import React, { useState, useEffect, useContext } from "react";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import SelectBox from "elements/SelectBox";
import api from "services/api";
import auth from "services/auth";
import AppContext from "contexts/AppContext";
import moneyFormatter from "services/moneyFormatter";
import ls from "services/ls";
import UserLeftArea from "elements/dashboardElements/UserLeftArea";
import { useSelector } from "react-redux";
import Translator, { __ } from "services/Translator";
import { Modal } from "react-bootstrap";

import PageHeadline from "../PageHeadline";

import FiatCashier from "elements/dashboardElements/FiatCashier";
import ModalCloseButton from "components/ModalCloseButton";

export default function Cashier(props) {
  // const __ = (text) => text;
  const userBalance = useSelector((state) => state.userBalance);

  const [selectedWallet, setSelectedWalelt] = useState(null);
  const [selectItems, setSelectItems] = useState([]);

  const { getUserBalance } = useContext(AppContext);

  const [deleteBonusModalOpen, setDeleteBonusModalOpen] = useState(false);

  const doDeleteBonuses = async () => {
    props.setSpinner(true);
    var response = await api.post("/delete-bonus");
    if (response.status === 200) {
      props.setSpinner(false);
      toggleDeleteBonusModalOpen();
      getUserBalance();
      props.showAlert(null, response.data.message);
    } else {
      props.showAlert(null, response.data.message);
    }
  };

  const toggleDeleteBonusModalOpen = () => {
    setDeleteBonusModalOpen(!deleteBonusModalOpen);
  };

  useEffect(() => {
    if (userBalance.wallets.length) {
      setSelectedWalelt(userBalance.wallets[0].currency);
      setSelectItems(
        userBalance.wallets.map((item) => {
          return { label: item.currency, value: item.value };
        })
      );
    }
  }, [userBalance]);

  const today =
    new Date().getFullYear() +
    "-" +
    new Date().getMonth() +
    "-" +
    new Date().getDate();

  return (
    <>
      <PageHeadline page_name="Cashier" />
      <div className="page_content_area">
        <div className="progress_chart_area">
          <div className="progress_content">
            <div className="content_title">
              {__("Balance")}
              <img
                src={require("assets/play365/images/userDashboard/mastercard.png")}
                alt={__("Mastercard Icon")}
              />
            </div>
            <div className="content_details">
              <div className="text_section">
                <h3 className="balance">{"$" + userBalance.total_balance}</h3>
                <div className="date_details">
                  <div className="paragraph no_margin white">
                    {__("Current Date")}
                  </div>
                  <div className="date_value">{today}</div>
                </div>
              </div>
              <div className="progress_section">
                <CircularProgressbarWithChildren
                  className="progress_container"
                  value={userBalance.total_balance}
                  counterClockwise={true}
                >
                  <div className="progress_value">
                    {"$" + userBalance.total_balance}
                  </div>
                </CircularProgressbarWithChildren>
              </div>
            </div>
          </div>
          <div className="progress_content chart_area">
            <div className="content_title">{__("Cash Balance")}</div>
            <div className="content_details">
              <div className="text_section">
                <h3 className="balance">{"$" + userBalance.cash_balance}</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="bonus_intro">
          <div className="intro_title">
            {__("Bonus Balance")}: {"$" + userBalance.bonus_balance}
          </div>
          <div className="intro_title">
            {__("Bonus Unlock Progress")}: (
            {"$" + userBalance.wagering_requirements_achieved}/
            {"$" + userBalance.wagering_requirements_total})
          </div>
          <button
            type="button"
            onClick={toggleDeleteBonusModalOpen}
            className="commonBtn red "
          >
            {__("Delete Bonus")}
          </button>
        </div>

        <Modal show={deleteBonusModalOpen} onHide={toggleDeleteBonusModalOpen}>
          <Modal.Body className={"login_modal " + props.theme}>
            <ModalCloseButton onClick={toggleDeleteBonusModalOpen} />

            <div className="modal_headline">
              {__("Are you sure to delete your bonus balance?")}
            </div>

            <div className="row">
              <div className="col-6 col-md-4 offset-md-2 col-lg-3 offset-lg-3">
                <button
                  type="button"
                  className="commonBtn"
                  onClick={toggleDeleteBonusModalOpen}
                >
                  {__("No")}
                </button>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
                <button
                  type="button"
                  className="commonBtn red"
                  onClick={doDeleteBonuses}
                >
                  {__("Yes")}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <br />
        <FiatCashier {...props} />
      </div>
    </>
  );
}
